import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { KeyEventUtil } from 'utils'

import * as ActivoFijoService from 'services/activosFijos.service'

const CodigoFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue, handleChange }) => {
  const [generandoCodigo, setGenerandoCodigo] = React.useState(false)

  const clickGenerarCodigo = React.useCallback(() => {
    setGenerandoCodigo(true)
    ActivoFijoService.nuevoCodigo()
      .then(({ data }) => {
        setGenerandoCodigo(false)
        setFieldValue('codigo', data.nuevoCodigo)
        setFieldValue('codigoGeneradoFlag', true)
        KeyEventUtil.leaveOnKeyEvent('input-descripcion')
      })
      .catch(() => setGenerandoCodigo(false))
  }, [setFieldValue])

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      setFieldValue('codigoGeneradoFlag', false)
    },
    [handleChange, setFieldValue]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-descripcion', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='CÓDIGO' htmlFor='input-codigo' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.InputGroup>
          <Field name='codigo'>
            {({ field }) => (
              <Form.InputText
                {...field}
                id='input-codigo'
                isInvalid={iTouched && iError}
                onChange={onChange}
                onKeyDown={onKeyDown}
              />
            )}
          </Field>
          <Form.InputGroup.Append>
            <Button
              disabled={fIsSubmitting || generandoCodigo}
              color='secondary'
              onClick={clickGenerarCodigo}
            >
              Generar
            </Button>
          </Form.InputGroup.Append>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Form.InputGroup>
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
